import { z } from "zod";

// Form-gating validation (submit stays disabled until valid). Authoritative checks
// happen at Firebase Auth; these just keep obviously-invalid input from being sent.
const email = z
  .string()
  .trim()
  .min(1, "Email is required")
  .refine((v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v), "Enter a valid email address");

export const signInSchema = z.object({
  email,
  password: z.string().min(1, "Password is required"),
});

export const signUpSchema = z.object({
  displayName: z.string().trim().min(1, "Enter your name"),
  email,
  // Firebase Auth requires at least 6 characters.
  password: z.string().min(6, "Use at least 6 characters"),
});

export const forgotPasswordSchema = z.object({ email });

export const isValid = (schema: z.ZodType, value: unknown): boolean => schema.safeParse(value).success;
